import React, { useContext, useEffect, useMemo, useState } from 'react';

import { useParams } from 'react-router-dom';
import { useQuery } from 'hooks';
import Contact from './Contact';
import Ticket from './Ticket';
import PrintContext from './Ticket/context';
import { IParticipantData } from 'interfaces/attendanceList';
import attendanceListService from 'services/attendanceList';
import Toast from 'components/Shared/Toast';

import * as S from './styles';
import { Button, Col, Row } from 'antd';
import { CustomizedCheckCircleOutlineIcon } from 'components/Shared/CheckCircleIcon';

type ParticipantUrlParams = {
  ciphertext: string;
};

const Content = () => {
  const { isPrinting, setIsPrinting } = useContext(PrintContext);

  const [participantData, setParticipantData] = useState<IParticipantData[]>(null);

  const { ciphertext } = useParams<ParticipantUrlParams>();

  const query = useQuery();
  const utmSource = query.get('utm_source');

  const showTransferButton = useMemo(() => {
    if (!participantData) return false;
    return participantData.some(participant => participant.status !== 'presence_confirmed');
  }, [participantData]);

  useEffect(() => {
    attendanceListService.getParticipantDataByCipherText(ciphertext, utmSource).subscribe({
      next: data => {
        setParticipantData(data);
      },
      error: () => {
        Toast.error('Ocorreu um erro.');
      },
    });
  }, [ciphertext, utmSource]);

  useEffect(() => {
    if (isPrinting) {
      window.print();

      setIsPrinting(false);
    }
  }, [isPrinting, setIsPrinting]);

  return (
    <Row>
      <Col span={24}>
        {utmSource === 'thankyou_page' ? (
          <>
            <Row className={isPrinting && 'noprint'} justify='center'>
              <CustomizedCheckCircleOutlineIcon />
            </Row>

            <Row className={isPrinting && 'noprint2'} justify='center'>
              <S.ApprovedPaymentTitle>Pagamento aprovado!</S.ApprovedPaymentTitle>
            </Row>
          </>
        ) : (
          <>
            <Row justify='center' className={isPrinting && 'noprint2'}>
              <S.CustomizedConfirmationNumberOutlinedIcon />
            </Row>

            <Row justify='center' className={isPrinting && 'noprint2'}>
              <S.Title>Acesse seus ingressos</S.Title>
            </Row>
          </>
        )}

        {participantData && (
          <Row justify={'end'} className={isPrinting && 'noprint2'}>
            <Button onClick={() => setIsPrinting(true)}>
              {participantData.length > 1 ? 'Imprimir Todos' : 'Imprimir'}
            </Button>
          </Row>
        )}

        {participantData?.map(participant => (
          <Ticket participantData={participant} key={participant.attendance_id} />
        ))}

        {showTransferButton && (
          <Row style={{ marginTop: '16px' }}>
            {participantData && participantData.length >= 2 && (
              <Button
                href={`/my-tickets/${participantData[0]?.event_id}?utm_source=printPage`}
                target='_blank'
                rel='noopener noreferrer'
              >
                Transferir ingressos
              </Button>
            )}
          </Row>
        )}

        <Row justify='space-between' className={isPrinting && 'noprint2'} style={{ marginTop: '16px' }}>
          {participantData && (
            <Contact
              eventId={participantData[0]?.event_id}
              name={participantData[0]?.name}
              email={participantData[0]?.email}
            />
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default Content;
